// extracted by mini-css-extract-plugin
module.exports = {"container":"whatsapp-button-module--container--1bVrT","buttonLink":"whatsapp-button-module--button-link--2zGDX","label":"whatsapp-button-module--label--3JDGP"};